import { NotificationType } from '../../models/Notifications'
import bookingImport from './notificationContainers/bookingImport'
import reservationIssues from './notificationContainers/reservationIssues'
import iCalImport from './notificationContainers/iCalImport'
import bookingSync from './notificationContainers/bookingSync'
import notificationError from './notificationContainers/notificationError'
import propertyCreate from './notificationContainers/propertyCreate'
import propertyDelete from './notificationContainers/propertyDelete'
import propertyEdit from './notificationContainers/propertyEdit'
import iCalUrlIssue from './notificationContainers/iCalUrlIssue'
import iCalExport from './notificationContainers/iCalExport'
import licenseExtended from './notificationContainers/licenseExtended'
import licenseRenewed from './notificationContainers/licenseRenewed'
import licenseExpired from './notificationContainers/licenseExpired'
import airbnbImport from './notificationContainers/airbnbImport'
import airbnbExport from './notificationContainers/airbnbExport'
import airbnbError from './notificationContainers/airbnbError'
import airbnbImportError from './notificationContainers/airbnbImportError'

export default function(notification, markRead = null, size = 1) {
  switch (notification.type as NotificationType) {
    case NotificationType.BookingImport:
      return bookingImport(notification, markRead, size)
    case NotificationType.ReservationIssues:
      return reservationIssues(notification, size)
    case NotificationType.ICalImport:
      return iCalImport(notification, markRead, size)
    case NotificationType.ICalReservationIssues:
      return reservationIssues(notification, size)
    case NotificationType.BookingSynchronization:
      return bookingSync(notification, size)
    case NotificationType.NotificationError:
      return notificationError(notification, size)
    case NotificationType.PropertyCreate:
      return propertyCreate(notification, size)
    case NotificationType.PropertyDelete:
      return propertyDelete(notification, size)
    case NotificationType.PropertyEdit:
      return propertyEdit(notification, size)
    case NotificationType.ICalUrlIssue:
      return iCalUrlIssue(notification, size)
    case NotificationType.ICalExport:
      return iCalExport(notification, markRead, size)
    case NotificationType.ICalLicenseExtended:
      return licenseExtended(notification, size)
    case NotificationType.BookingLicenseExtended:
      return licenseExtended(notification, size)
    case NotificationType.ICalLicenseRenewed:
      return licenseRenewed(notification, size)
    case NotificationType.BookingLicenseRenewed:
      return licenseRenewed(notification, size)
    case NotificationType.ICalLicenseExpired:
      return licenseExpired(notification, size)
    case NotificationType.BookingLicenseExpired:
      return licenseExpired(notification, size)
    case NotificationType.AirbnbImport:
      return airbnbImport(notification, markRead, size)
    case NotificationType.AirbnbExport:
      return airbnbExport(notification, markRead, size)
    case NotificationType.AirbnbError:
      return airbnbImportError(notification, size)
    case NotificationType.AirbnbExportError:
      return airbnbError(notification, size)
  }
}
